import { useMemo } from 'react'

const themeFields = [
	'backgroundImage',
	'backgroundShading',
	'showBorders',
	'headingTextFont',
	'headingFontSize',
	'bodyTextFont',
	'fontSize',
]

const paletteFields = [
	'backgroundDefault',
	'backgroundPaper',
	'textPrimary',
	'textSecondary',
	'textSecondary',
	'primary',
	'secondary',
	'borderTop',
	'borderBottom',
]

const getMetaValues = (metaData, fields) =>
	_.reduce(
		fields,
		(acc, name) => {
			if (metaData[name]) {
				acc[name] = name === 'backgroundImage' ? metaData[name].image : metaData[name].metaValue
			}
			return acc
		},
		{},
	)

/**
 *
 * @param {Object.<string, PageMetaData>} metaData
 */
const useThemeSettings = metaData => {
	return useMemo(() => {
		return {
			...getMetaValues(metaData, themeFields),
			palette: getMetaValues(metaData, paletteFields),
		}
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [
		metaData.backgroundDefault,
		metaData.backgroundImage,
		metaData.backgroundPaper,
		metaData.backgroundShading,
		metaData.bodyTextFont,
		metaData.borderBottom,
		metaData.borderTop,
		metaData.fontSize,
		metaData.headingFontSize,
		metaData.headingTextFont,
		metaData.showBorders,
		metaData.textPrimary,
		metaData.textSecondary,
		metaData.primary,
		metaData.secondary,
	])
}

export default useThemeSettings
